import { Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Toaster } from "react-hot-toast";

import { store, persistor } from "./store/store";

import ErrorBoundary from './ErrorBoundary'
import { history } from "./_helpers/utilities";
import Routes from "./routes/Routes";


function App() {

  return (
    <>
      <Toaster />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={history}>
            <ErrorBoundary>
              <Routes />
            </ErrorBoundary>
          </Router>
        </PersistGate>
      </Provider>
    </>
  )
}

export default App